import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { NumberParam, useQueryParams, withDefault } from 'use-query-params';

import { useUsersApi } from '@api/users';
import { User, UserConsent } from '@types';
import { BasePreloader, Pagination } from '@components';
import moment from 'moment';

interface Props {
  user?: User;
}

export const Consents: React.FC<Props> = (props) => {
  const usersApi = useUsersApi();
  const location = useLocation();
  const [data, setData] = useState<UserConsent[]>([]);
  const [total, setTotal] = React.useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const defaultQuery = React.useMemo(
    () => ({
      section: withDefault(NumberParam, 1),
      page: withDefault(NumberParam, 1),
      perPage: withDefault(NumberParam, 15),
    }),
    []
  );
  const [query, setQuery] = useQueryParams(defaultQuery);

  useEffect(() => {
    loadData();
    return () => usersApi.cancelAllRequests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const loadData = async () => {
    setIsLoaded(false);
    try {
      const res = await usersApi.getUserConsents(props.user?.id || '', { ...query });
      setTotal(res.data.total || 0);
      setData(res.data.data);
      setIsLoaded(true);
    } catch (err) {
      if (usersApi.isCancel(err)) {
        return;
      }
    }
  };

  if (!isLoaded) {
    return (
      <div className="d-flex justify-content-center py-5">
        <BasePreloader />
      </div>
    );
  }

  return (
    <div>
      <div>
        <h2>Souhlasy</h2>
      </div>

      <div className="component-admin-auctions-table mt-4">
        <Table className="border-bottom-0">
          <thead>
            <tr>
              <th className="text-nowrap text-center">Souhlas s podmínkami portálu</th>
              <th className="text-nowrap text-center">Souhlas s podmínkami ochrany osobních údajů</th>
              <th className="text-nowrap text-center">Souhlas se zasíláním newsletterů</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={`list-item-${index}`} className="border-top">
                <td className="text-center">
                  {item.portalConsent ? 'ANO - ' + moment(item.portalConsentDt).format('DD.MM.YYYY HH:mm') : 'NE'}
                </td>
                <td className="text-center">
                  {item.gdprConsent ? 'ANO - ' + moment(item.gdprConsentDt).format('DD.MM.YYYY HH:mm') : 'NE'}
                </td>
                <td className="text-center">
                  {item.newsletter ? 'ANO - ' + moment(item.newsletterDt).format('DD.MM.YYYY HH:mm') : 'NE'}
                </td>
              </tr>
            ))}
            {data.length < 1 && (
              <tr>
                <td className="text-left" colSpan={100}>
                  Nebyla nalezena žádná data.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div>
        {total > query.perPage && (
          <div className="mt-2">
            <Pagination
              page={query.page}
              perPage={query.perPage}
              totalRows={total}
              onPageChange={(page, perPage) => setQuery({ ...query, page: page, perPage: perPage }, 'push')}
            />
          </div>
        )}
      </div>
    </div>
  );
};
